import type { ComponentType } from 'react';
import {
  ArrowRight,
  Bell,
  Box,
  Compass,
  ExternalLink,
  Ghost,
  GitPullRequest,
  Inbox,
  KeyRound,
  LayoutDashboard,
  Layers,
  LockKeyhole,
  Megaphone,
  MessageCircle,
  Play,
  Shield,
  ShieldCheck,
  Sparkles,
  TerminalSquare,
  Users,
  Workflow,
  Zap,
} from 'lucide-react';
import type { MarketingIconName } from '../shared/blocks';

type IconComponent = ComponentType<{ className?: string }>;

export const MARKETING_ICON_MAP: Record<MarketingIconName, IconComponent> = {
  ArrowRight,
  Bell,
  Box,
  Compass,
  ExternalLink,
  Ghost,
  GitPullRequest,
  Inbox,
  KeyRound,
  LayoutDashboard,
  Layers,
  LockKeyhole,
  Megaphone,
  MessageCircle,
  Play,
  Shield,
  ShieldCheck,
  Sparkles,
  TerminalSquare,
  Users,
  Workflow,
  Zap,
};

export function resolveIcon(name: MarketingIconName | string): IconComponent {
  if (name in MARKETING_ICON_MAP) {
    return MARKETING_ICON_MAP[name as MarketingIconName];
  }
  return Sparkles;
}
